<template>
  <b-container>
    <b-row class="text-left">
      <b-col></b-col>
      <b-col cols="10" class="mb-3 mt-3">
        <h1>Users</h1>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row>
      <b-col>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      </b-col>
    </b-row>
    <LoadingIndicator 
      v-if="isLoading"
      topic="Users"
    />
    <div v-if="!isLoading && showList">
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="5" class="mb-3">
            <div class="custom-search">
              <b-input-group>
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input type="text" placeholder="Enter search text" v-model="searchFilter"></b-form-input>
              </b-input-group>
            </div>
        </b-col>
        <b-col cols="5" class="mb-3 text-right">
          <b-button variant="primary" @click="showUserModal">Add New User</b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="text-center">
        <b-col></b-col>
        <b-col cols="10">
          <b-table hover responsive
              class="custom-table"
              :items="users" 
              :fields="fields" 
              :filter="searchFilter"
              @row-clicked="openUser">
            <template v-slot:cell(permissionLevel)="data">
              <b-badge v-if="data.item.permissionLevel === 'Sponsor'" variant="primary">
                Executive
              </b-badge>
              <b-badge v-else-if="data.item.permissionLevel  === 'Admin'" variant="danger">
                Admin
              </b-badge>
              <b-badge v-else-if="data.item.permissionLevel  === 'Respondent'" variant="warning">
                Respondent
              </b-badge>
            </template>

            <template v-slot:cell(admin)="data">
              <span v-if="data.item.admin">
                <b-icon icon="check2" aria-label="Yes" title="Yes">Yes</b-icon>
              </span>
              <span v-else>
                <b-icon icon="x" aria-label="No" title="No">No</b-icon>
              </span>
            </template>

          </b-table>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <EditUserModal
      ref="add-user-modal"
      :userEmails="userEmails"
      @submitted="onAddUserSubmit"
    >
    </EditUserModal>
  </b-container>
</template>
<script>
import axios from "axios";
import EditUserModal from "@/modal-components/EditUserModal.vue";

export default {
  name: "UserList",
  components: {
    EditUserModal
  },
  data() {
    return {
      errors: [],
      users: [],
      searchFilter: null,
      isLoading: false,
      showList: false,
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "email", sortable: true },
        { key: "permissionLevel", label: "Level", sortable: true },
        { key: "admin", label: "System Admin", sortable: true },
      ]
    };
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    this.getUserList();
  },

  methods: {
    showUserModal(){
      this.$refs['add-user-modal'].show();
    },
    getUserList() {
      this.isLoading = true;
      axios
        .get(`${this.$api_url}/users/list`, this.getReqConfig())
        .then(response => {
          this.users = response.data;
          this.showList = true;
          let ordering =["Sponsor", "Admin", "Respondent", "None"];
          this.users
            .sort((a, b) => a.name < b.name ? -1 : 1)
            .sort((a, b) => ordering.indexOf(a.permissionLevel) < ordering.indexOf(b.permissionLevel) ? -1 : 1)
            .sort((a, b) => a.admin === b.admin ? 0 : a.admin ? -1 : 1)
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() =>{
          this.isLoading = false;
        });
    },
    onAddUserSubmit() {
      this.getUserList();
    },
    openUser(item) {
      this.$router.push('/user/' + item.userId);
    }
  },
  computed: {
    userEmails(){
      return this.users.map(u => u.email);
    }
  },
};
</script>
<style scoped>
.nowrap {
  display: flex;
  white-space: nowrap;
}
</style>

